﻿export class NavigationPaneComponent {
    constructor(selector) {
        const self = this;
        self.navigationPaneDom = document.querySelector(`${selector}`);

        self.SELECTORS = {
            MENU: 'navigation__menu',
            ICON_OPEN: 'icon-first',
            ICON_ROTATE: 'icon--rotated',
            BUTTON: 'navigation__collaps-button',
            VISIBLE_STATE: 'navigation--visible',
            ACTIVE_BUTTON: 'active'
        };

        self.paneVisible = true;
    }

    init() {
        const self = this;
        self.toggleNavigationPaneVisibility(self.paneVisible);
        self.renderNavigationButtons();
        self.addEventListeners();
        //TODO, move render here.
    }

    addEventListeners() {
        const self = this;
        $('.navigation__collaps-button').on("click", function (e) {
            let state = !$('.navigation__menu').hasClass('navigation--visible');
            self.toggleNavigationPaneVisibility(state);
            
        });
    }

    renderNavigationButtons() {
        const $navigation = $('.navigation');
        const navigationButtons = $navigation.find('.navigation__item');
        const currentPage = window.location.pathname; // Get current page URL path

        navigationButtons.each(function () {
            const $currentButton = $(this);
            const $linkEl = $currentButton.find('a');
            const link = $linkEl.attr('href'); // Get the value of the asp-page attribute
            if (currentPage.endsWith(link.replace('./', ''))) {
                // Match found: Add selected class
                $currentButton.addClass('navigation__item--selected');
                return false; 
            } else {
                // No match: Remove selected class
                $currentButton.removeClass('navigation__item--selected');
            }
        });
    }


    toggleNavigationPaneVisibility(state) {
        const self = this;
        //if ($('.navigation__menu').hasClass('navigation--visible')) {
        //    $('.icon-first').removeClass('d-none');
        //    $('.icon-second').addClass('d-none');
        //    $('.navigation__menu').removeClass('navigation--visible');
        //} else {
        //    $('.icon-first').addClass('d-none');
        //    $('.icon-second').removeClass('d-none');
        //    $('.navigation__menu').addClass('navigation--visible');
        //}

        if (state) {
            $(`.${self.SELECTORS.ICON_OPEN}`).addClass(`${self.SELECTORS.ICON_ROTATE}`);
            $(`.${self.SELECTORS.MENU}`).addClass('navigation--visible');
        } else {
            $(`.${self.SELECTORS.ICON_OPEN}`).removeClass(`${self.SELECTORS.ICON_ROTATE}`);
            $(`.${self.SELECTORS.MENU}`).removeClass('navigation--visible');
        }
        
    }
}